import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import download from "../../../helpers/download";
import { getRptAlertaDetalhe } from "./services";

const initialState: any = {
  status: "",
  noContent: true
};

export const actionGetRptAlertaDetalhe: any = createAsyncThunk<any, any>(
  "ACTION_GET_GET_RPT_ALERTA_DETALHE",
  async (data) => {
    
    const result = await getRptAlertaDetalhe(data);

    download(result, {ext: data.reportType, fileName: `relatorio-alertas`});
    
    return result
  }
);

const sliceGetRptAlertaDetalhe = createSlice({
  name: "GET_RPT_ALERTA_DETALHE",
  initialState,
  reducers: {},
  extraReducers: {
    [actionGetRptAlertaDetalhe.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetRptAlertaDetalhe.fulfilled]: (state, { payload: { status } }) => {
      state.status = "success";
      state.status = status === 204
    },
    [actionGetRptAlertaDetalhe.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetRptAlertaDetalhe.reducer
